import { useCallback, useEffect, useState } from 'react'
import { updateProfile } from 'src/redux/slices/user/endpoints'
import { User } from 'src/types/database-model'
import { TextFieldOnChangeEvent } from 'src/types/event-handlers'

import { Grid, IconButton, TextField, Typography } from '@material-ui/core'
import CancelIcon from '@material-ui/icons/Cancel'
import CheckCircleIcon from '@material-ui/icons/CheckCircle'
import EditIcon from '@material-ui/icons/Edit'

///// Types
type ProfileTextFieldProps = {
  field: keyof User
  label: string
  profile: User | null
}

///// Component
const ProfileTextField: React.FC<ProfileTextFieldProps> = ({ field, label, profile }) => {
  const [isEditing, setIsEditing] = useState(false)
  const [value, setValue] = useState(profile?.[field])
  const [trigger, { data, isLoading }] = updateProfile.useMutation()

  useEffect(() => {
    setValue(profile?.[field])
  }, [profile?.[field]])

  const toggleIsEditing = useCallback(() => {
    setIsEditing((prev) => !prev)
    setValue(profile?.[field])
  }, [profile?.[field]])

  const handleChange = useCallback((e: TextFieldOnChangeEvent) => setValue(e.target.value), [])

  const handleConfirm = useCallback(() => {
    if (!profile?.id) return
    trigger({ [field]: value, id: profile.id })
    toggleIsEditing()
  }, [field, value, profile, trigger, toggleIsEditing])
  return (
    <>
      <Typography variant='h5'>{label}</Typography>
      {!isEditing && (
        <Grid container alignItems='center'>
          <Grid item>
            <Typography>{profile?.[field]}</Typography>
          </Grid>
          <Grid item>
            <IconButton onClick={toggleIsEditing}>
              <EditIcon />
            </IconButton>
          </Grid>
        </Grid>
      )}
      {isEditing && (
        <Grid container alignItems='center'>
          <Grid item>
            <TextField value={value} label={label} onChange={handleChange} />
          </Grid>
          <Grid item>
            <IconButton onClick={handleConfirm} color='primary'>
              <CheckCircleIcon />
            </IconButton>
          </Grid>
          <Grid item>
            <IconButton color='primary' onClick={toggleIsEditing}>
              <CancelIcon />
            </IconButton>
          </Grid>
        </Grid>
      )}
    </>
  )
}

export default ProfileTextField
